<template>
  <v-card
    class="card"
    :class="$vuetify.breakpoint.mobile ? 'help-card-mobile' : ''"
    :height="$vuetify.breakpoint.mobile ? '' : '100%'"
  >
    <div class="d-flex bg-titre">
      <div
        class="d-flex pl-3 mr-auto"
        :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
      >
        <div class="titre-h3 secondary--text align-self-center">
          {{ titreFormatted }}
        </div>
        <AgrButton
          v-if="boutonTitre"
          elevation="0"
          :class="$vuetify.breakpoint.mobile ? '' : 'ml-3'"
          class="btn-secondaire  align-self-center"
          color="primary darken-1"
          outlined
          large
          @click="onOpenModalSaisieContrat()"
        >
          <span class="action text-truncate --text-branche">{{ boutonTitre.libelle }}</span>
        </AgrButton>
      </div>
      <v-btn
        text
        class="btn-close"
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <slot name="baseCardHelpContent" />

    <InformationAbonnementModal
      v-if="isOpenModalAideInformationAbonnement"
      :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
      :code-feature="infosAbonnement?.code"
      :texte="infosAbonnement?.texte"
      :titre="infosAbonnement?.titre"
      :is-conseiller-pv-affiche="!isAbonneCulturial"
      @close="isOpenModalAideInformationAbonnement = false"
    />
    <v-dialog
      v-model="isOpenModalListeContrats"
      :scrim="false"
      scrollable
      :fullscreen="!$vuetify.breakpoint.mobile"
      :transition="$vuetify.breakpoint.mobile ? 'dialog-bottom-transition' : 'slide-x-transition'"
      @click:outside="closeForm"
    >
      <ListeContratsAdherentModal
        class="pa-3"
        :type-culture-selected="typeCultureSelected"
        :contrats="contratsModifiable"
        :loading="loading.contrat"
        @openForm="openForm"
        @closeForm="closeForm"
        @reload="loadContrats"
        @close="onCloseModalEditContrat()"
      />
    </v-dialog>
    <AgrButton
      v-if="hasBtnVoirContrat"
      elevation="0"
      class="btn-secondaire ml-3 my-3 align-self-center"
      color="primary darken-1"
      outlined
      :loading="loading.contrat"
      large
      @click="onOpenModalListeContrat()"
    >
      <span class="action text-truncate --text-branche">Voir mes ventes</span>
    </AgrButton>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import capitalize from '@/filters/string.filter'
import {clone} from '@/utils/clone'
import { AgrButton } from '@agrial/ui'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import ListeContratsAdherentModal from '../../saisie-contrats/components/modal/liste-contrats-adherent-modal.vue'

export default {
  name: 'DetailAnalyseModal',
  components: {AgrButton, InformationAbonnementModal, ListeContratsAdherentModal},
  props: {
    titre: {
      type: String,
      default: 'Information'
    },
    boutonTitre: {
      type: Object,
      default: null
    },
    infosAbonnement: {
      type: Object,
      default: null
    },
    typeCultureSelected: {
      type: Object,
      default: null
    },
    hasBtnVoirContrat: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loading: {
        contrat: false
      },
      erreur: {
        contrat: false
      },
      contratsModifiable: [],
      isOpenModalAideInformationAbonnement: false,
      isOpenModalListeContrats: false
    }
  },
  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      contractualisation: 'contratVente/contractualisation',
    }),
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    titreFormatted (){
      return capitalize.capitalize(this.titre)
    }
  },

  methods: {
    ...mapActions({
      getContrats: 'contratVente/getContractualisation',
      incrementerAccesSouscriptionAbonnement : 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement'
    }),
    onClickInformationAbonnement () {
      this.isOpenModalAideInformationAbonnement = true
      this.incrementerAccesSouscriptionAbonnement(this.infosAbonnement.code)
    },
    onOpenModalSaisieContrat () {
      this.$emit('openModalSaisieContrat')
    },
    onOpenModalListeContrat () {
      this.loadContrats()
    },
    reload () {
      this.loadContrats()
    },
    loadContrats () {
      this.loading.contrat = true
      this.erreur.contrat = false
      this.getContrats(this.typeCultureSelected.code)
        .then(() => {
          let contractualisationModifiable = clone(this.contractualisation)
          let contrats = contractualisationModifiable.contratVentes
          contrats.forEach((c) => {
            c.isOpenForm = false
          })
          this.contratsModifiable = contrats.sort((a, b) => (b.contratAgrial - a.contratAgrial))
          this.isOpenModalListeContrats = true
        })
        .catch(() => {
          this.erreur.contrat = true
        })
        .finally(() => {
          this.loading.contrat = false
        })
    },
    openForm (contrat) {
      this.contratsModifiable.forEach((c) => {
        c.isOpenForm = c.id === contrat.id
      })
    },
    closeForm () {
      this.contratsModifiable.forEach((c) => {
        c.isOpenForm = false
      })
    },
    onCloseModalEditContrat () {
      this.isOpenModalListeContrats = false
    },
    onClose () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.help-card-mobile {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  overflow-y: auto;
}
.card.help-card-mobile {
  max-height: calc(100% - 56px);
}
.bg-titre {
  height: 70px;
}
@media (max-width: 960px) {
  .bg-titre {
    height: auto;
    padding: 12px 0;
  }
}
.card {
  border-radius: 0px !important;
  background-color: #f1f2f5;
}
.btn-close {
  position: absolute;
  right: 0;
}
</style>